import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Guides from './pages/Guides';
import ChoosingCasino from './pages/ChoosingCasino';
import BonusesGuide from './pages/BonusesGuide';
import BankrollGuide from './pages/BankrollGuide';
import GameSelectionGuide from './pages/GameSelectionGuide';
import ResponsibleGamingGuide from './pages/ResponsibleGamingGuide';
import PaymentMethodsGuide from './pages/PaymentMethodsGuide';
import MobileGamingGuide from './pages/MobileGamingGuide';
import LiveDealerGuide from './pages/LiveDealerGuide';
import MaximizingWinningsGuide from './pages/MaximizingWinningsGuide';
import WinamaxNews from './pages/WinamaxNews';
import ZeturfNews from './pages/ZeturfNews';
import BwinNews from './pages/BwinNews';
import UkgcNews from './pages/UkgcNews';
import CryptoNews from './pages/CryptoNews';
import MobileNews from './pages/MobileNews';
import ResponsibleNews from './pages/ResponsibleNews';
import CrossplatformNews from './pages/CrossplatformNews';
import VipNews from './pages/VipNews';
import Reviews from './pages/Reviews';
import PubReview from './pages/PubReview';
import NRGReview from './pages/NRGReview';
import MrPlayReview from './pages/MrPlayReview';
import Slots from './pages/Slots';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import CookiesPolicy from './pages/CookiesPolicy';
import ResponsibleGaming from './pages/ResponsibleGaming';

// ScrollToTop component to ensure page starts from top on route changes
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/slots" element={<Slots />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/cookies-policy" element={<CookiesPolicy />} />
        <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/guides/choosing-casino" element={<ChoosingCasino />} />
        <Route path="/guides/bonuses-promotions" element={<BonusesGuide />} />
        <Route path="/guides/bankroll-management" element={<BankrollGuide />} />
        <Route path="/guides/game-selection" element={<GameSelectionGuide />} />
        <Route path="/guides/responsible-gaming" element={<ResponsibleGamingGuide />} />
        <Route path="/guides/payment-methods" element={<PaymentMethodsGuide />} />
        <Route path="/guides/mobile-gaming" element={<MobileGamingGuide />} />
        <Route path="/guides/live-dealer" element={<LiveDealerGuide />} />
        <Route path="/guides/maximizing-winnings" element={<MaximizingWinningsGuide />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/reviews/pub" element={<PubReview />} />
        <Route path="/reviews/nrg" element={<NRGReview />} />
        <Route path="/reviews/mrplay" element={<MrPlayReview />} />
        <Route path="/news" element={<Home />} />
        <Route path="/news/winamax-expansion" element={<WinamaxNews />} />
        <Route path="/news/zeturf-jackpots" element={<ZeturfNews />} />
        <Route path="/news/bwin-live-casino" element={<BwinNews />} />
        <Route path="/news/ukgc-2025-updates" element={<UkgcNews />} />
        <Route path="/news/crypto-casinos-uk" element={<CryptoNews />} />
        <Route path="/news/mobile-gaming-2025" element={<MobileNews />} />
        <Route path="/news/responsible-gambling-2025" element={<ResponsibleNews />} />
        <Route path="/news/cross-platform-gaming" element={<CrossplatformNews />} />
        <Route path="/news/vip-programs-2025" element={<VipNews />} />
      </Routes>
    </Router>
  );
}

export default App;
